import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Menu} from "antd";
import {propertyIsDefined} from "../utils";
import SubChildren from "./SubChildren";
import uuidv4 from "uuid";
import {connect} from "react-redux";

const mapStateToProps = state => ({
    isSidebarCollapsed: state.app.isSidebarCollapsed,
});

const SidebarSubMenu = ({parent, subMenuProps, isSidebarCollapsed, t, tReady, dispatch, ...other}) => {
    if (!parent.children.filter(({isDivider}) => !isDivider).length) {
        return null;
    }
    return (
        <Menu.SubMenu
            className="sidebar__menu__item"
            key={parent.path}
            title={
                <div
                    title={(propertyIsDefined(isSidebarCollapsed) ? isSidebarCollapsed : true) ? t(parent.label) : null}>
                    <div className="sidebar__menu__item__icon__container">
                        <img
                            alt={t(parent.label)}
                            className="sidebar__menu__item__icon"
                            src={parent.redIconPath}
                        />
                    </div>
                    <span className="sidebar__menu__item__label">
                {t(parent.label)}
              </span>
                </div>
            }
            {...subMenuProps}
            {...other}>
            {parent.children.map(child =>
                !child.isDivider
                    ? <SubChildren key={child.path} parent={parent} child={child} subMenuProps={subMenuProps}/>
                    : <Menu.Divider key={uuidv4()}/>)}
        </Menu.SubMenu>
    )
}

export default compose(translate(), connect(mapStateToProps))(SidebarSubMenu);